import React, { Component } from "react";
import { Link } from "react-router-dom";
import draft_logo from "../../assets/img/draft_logo.png";
import { links } from "../../utils/constants";
import navbarStyles from "./navbar.module.css";

class NavBar extends Component {
  myNav;
  constructor(props) {
    super(props);
    this.myNav = React.createRef();
    // this.props.history.listen((location, action) => {
    // console.log('on route change', location, action);
    // })
    this.state = {
      scrolled: false,
      collapsed: false
    };
  }

  scrollListener = () => {
    if (window.scrollY >= this.myNav.current.offsetHeight) {
      this.myNav.current.classList.add("navbar-scrolled");
      this.myNav.current.classList.remove("navbar-scroll");
      this.setState({ scrolled: true });
    } else {
      this.myNav.current.classList.add("navbar-scroll");
      this.myNav.current.classList.remove("navbar-scrolled");
      this.setState({ scrolled: false });
    }
  };

  toggle = () => {
    this.setState(prevState => {
      return {
        ...prevState,
        collapsed: !prevState.collapsed
      }
    });
  }

  componentDidMount() {
    window.addEventListener("scroll", this.scrollListener, false);
  }

  componentWillUnmount() {
    window.removeEventListener("scroll", this.scrollListener, false);
  }

  render() {
    return (
      <nav
        className={`navbar navbar-expand-lg fixed-top navbar-scroll ${(this.props.location === "/" || this.props.location === "/about") && !this.state.collapsed
          ? ""
          : "bg-warning shadow"
          }`}
        ref={this.myNav}
      >
        <div className="container">
          <Link className="navbar-brand nav-link fs-6" to="/#">
            <img alt="Brand" class="logo" src={draft_logo} />
            <span className="ms-2">Mr-Draft</span>
          </Link>
          <button
            className={`navbar-toggler ${navbarStyles.toggle_btn_icon}`}
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarNav"
            aria-controls="navbarNav"
            aria-expanded="false"
            aria-label="Toggle navigation"
            onClick={() => this.toggle()}
          >
            {/* <span class="navbar-toggler-icon"></span> */}
            <i className="fa-solid fa-bars"></i>
          </button>
          <div className="collapse navbar-collapse" id="navbarNav">
            <ul className={`nav justify-content-center m-auto ${this.state.collapsed ? navbarStyles.collapsed : ''}`}>
              {links.nav.map((link) => (
                <li className="nav-item" key={link.value}>
                  <Link className="nav-link fs-6" to={link.linkRef}>
                    {link.label
                      .split(" ")
                      .map((w) => w[0].toUpperCase() + w.substring(1))
                      .join(" ")}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
          <ul className={`navbar-nav d-flex flex-row me-1 ${this.props.device === 'xs' || this.props.device === 'sm' || this.props.device === 'md' ? 'd-none' : ''}`}>
            <li className="nav-item me-3 me-lg-0 fs-5">
              <Link
                className={`nav-link ${this.state.scrolled ? "text-dark" : "text-white"
                  }`}
              >
                <i className="fa-brands fa-facebook"></i>
              </Link>
            </li>
            <li className="nav-item me-3 me-lg-0 fs-5">
              <a
                className={`nav-link ${this.state.scrolled ? "text-dark" : "text-white"
                  }`}
                href="tel:3476666818"
              >
                <i className="fa-solid fa-phone"></i>
              </a>
            </li>
            <li className="nav-item me-3 me-lg-0 fs-5">
              <a
                className={`nav-link ${this.state.scrolled ? "text-dark" : "text-white"
                  }`}
                href="mailto:1mrdraft@gmail.com"
              >
                <i className="fa-solid fa-envelope"></i>
              </a>
            </li>
          </ul>
        </div>
      </nav>
    );
  }
}

export default NavBar;
